<div class="header-container-new-save-pin">
    <span><img src="../../assets/icons/new_pin_updated.png" alt="New Pin Icon" class="new-save-pin-header-icon"> </span>
    <h1 mat-dialog-title  class="new-save-pin-header">{{ 'NEW-SAVE-PIN-DIALOG.TITLE' | translate }}</h1>
</div>

<form [formGroup]="saveNewPinForm">
    <div class="new-save-pin-input-container">
        <mat-form-field class="new-save-pin-input" appearance="outline">
            <mat-label>{{ 'NEW-SAVE-PIN-DIALOG.PIN-TYPE' | translate }}</mat-label>
            <mat-select formControlName="pinType" (selectionChange)="onPinTypeSelection($event)">
                <mat-select-trigger>
                    <span style="display: flex;flex-direction: row;align-items: center;">
                        <img src="{{'../../assets/icons/' + (pinType?.id ? pinIcons[pinType.id] : 'new_pin_updated.png')}}" alt="New Pin Icon" class="pin-icon">
                        <span>{{pinType?.name}}</span>
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let pinType of pinTypesList" [value]="pinType">
                    <span style="display: flex;flex-direction: row;align-items: center">
                        <img src="{{'../../assets/icons/' + (pinType?.id ? pinIcons[pinType.id] : 'new_pin_updated.png')}}" alt="New Pin Icon" class="pin-icon">
                        <span>{{pinType.name}}</span>
                    </span>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="saveNewPinForm.get('pinType').invalid"  class="error-notice">
                Required* - Pin Type
            </mat-error>
        </mat-form-field>
    </div>

    <div class="new-save-pin-input-container" *ngIf="isPinInputVisible">
        <mat-form-field class="new-save-pin-input" appearance="outline">
            <mat-label>{{'NEW-SAVE-PIN-DIALOG.PIN-NAME' | translate }}</mat-label>
            <input matInput formControlName="pinDescription" >
            <mat-error *ngIf="saveNewPinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error>
        </mat-form-field>
    </div>

</form>


<div mat-dialog-actions>
    <button mat-flat-button (click)="cancel()" type="button" class="cancel-new-save-pin">{{'NEW-SAVE-PIN-DIALOG.CANCEL' | translate }}</button>
    <button class="new-save-pin-delete-btn" mat-flat-button (click)="removePin()">{{'NEW-SAVE-PIN-DIALOG.REMOVE' | translate }}</button>
    <button class="new-save-pin-save-btn" mat-flat-button (click)="savePin()">{{'NEW-SAVE-PIN-DIALOG.SAVE' | translate }}</button>
</div>
